export default "__VITE_ASSET__DxRgUVAx__"